import React from 'react';
import ManagerDashboard from './ManagerDashboard';

interface ManagerLayoutProps {
  children?: React.ReactNode;
}

const ManagerLayout: React.FC<ManagerLayoutProps> = () => {
  // ManagerDashboard zaten AppBar + main content (ManagerWithSidebar) içeriyor
  // Fazladan <main> kapsayıcısı oluşturmaya gerek yok
  return <ManagerDashboard />;
};

export default ManagerLayout; 